import { render } from "./index.vue?vue&type=template&id=4c3dbcef&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4c3dbcef&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4c3dbcef"

export default script